import { render, staticRenderFns } from "./ToneladasCarregadas.vue?vue&type=template&id=52244784"
import script from "./ToneladasCarregadas.vue?vue&type=script&lang=js"
export * from "./ToneladasCarregadas.vue?vue&type=script&lang=js"
import style0 from "./ToneladasCarregadas.vue?vue&type=style&index=0&id=52244784&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports